import { GetDeliveryAddress, GetInvoiceAddress } from "./SchemaAPICalls";

const initialValidation = { msg: "", invalid: false };

export const handleOptionSelection = async (
  option,
  isInteralOrAdminUser,
  divisionId,
  setSelectedOption,
  setDelivery,
  setPost,
  setInvoiceAddressChild,
  resetDeliveryAddress,
  setCustomerIdChild
) => {
  if (!isInteralOrAdminUser) return;
  setSelectedOption(option);
  setDelivery([]);
  setPost("");
  setInvoiceAddressChild([]);
  resetDeliveryAddress();
  if (option) {
    setCustomerIdChild(option.customer_id.trim());
    const [deliveryData, invoiceData] = await Promise.all([
      GetDeliveryAddress(option.customer_id, divisionId),
      GetInvoiceAddress(option.customer_id, divisionId),
    ]);
    setDelivery(deliveryData);
    setPost(invoiceData);
    setInvoiceAddressChild(invoiceData);
  }
};

export const handleDeliveryChange = (
  event,
  delivery,
  setDefaultDelivery,
  SetDefaultDeliveryChild,
  setDelAddressDropValidation,
  resetDeliveryAddress,
  setSelectedDeliveryChild,
  setDelContactName,
  setDelCustomerName,
  setDelAddress1,
  setDelAddress2,
  setDelAddress3,
  setDelAddress4,
  setDelCountry,
  setDelPostalCode,
  setShipToID
) => {
  const value = event.target.value;
  setDefaultDelivery(value);
  SetDefaultDeliveryChild(value);

  if (value !== "0" && value !== "") {
    setDelAddressDropValidation(initialValidation);
  } else {
    resetDeliveryAddress();
  }

  if (value !== "0") {
    const selected = delivery.find((d) => d.shipToID === value);
    if (selected) {
      setSelectedDeliveryChild(selected);
      setDelContactName(selected.contact_name);
      setDelCustomerName(selected.delivery_customer_name);
      setDelAddress1(selected.delivery_address1);
      setDelAddress2(selected.delivery_address2);
      setDelAddress3(selected.delivery_address3);
      setDelAddress4(selected.delivery_address4);
      setDelCountry(selected.delivery_country_code);
      setDelPostalCode(selected.delivery_post_code);
      setShipToID(selected.shipToID);
    }
  }
};

export const resetDeliveryAddress = (
  setDelAddress1,
  setDelAddress4,
  setDelCustomerName,
  setDelAddress2,
  setDelPostalCode,
  setDelContactName,
  setDelAddress3,
  setDelCountry,
  setDefaultDelivery,
  SetDefaultDeliveryChild,
  setShipToID,
  setSelectedDeliveryChild
) => {
  setDelAddress1("");
  setDelAddress4("");
  setDelCustomerName("");
  setDelAddress2("");
  setDelPostalCode("");
  setDelContactName("");
  setDelAddress3("");
  setDelCountry("");
  setDefaultDelivery("0");
  SetDefaultDeliveryChild("0");
  setShipToID(0);
  setSelectedDeliveryChild("");
};

export const validateForm = (
  selectedOption,
  isInteralOrAdminUser,
  requestNewAddress,
  isCollectOrder,
  delContactName,
  setContactValidation,
  delCustomerName,
  setCompanyNameValidation,
  delCountry,
  setCountryCodeValidation,
  delAddress1,
  setAddress1Validation,
  defaultDelivery,
  setDelAddressDropValidation
) => {
  let invalid = false;
  if (!selectedOption && isInteralOrAdminUser) invalid = true;

  if (requestNewAddress && !isCollectOrder) {
    if (!delContactName) {
      setContactValidation({
        msg: "Please Enter Contact Name",
        invalid: true,
      });
      invalid = true;
    }
    if (!delCustomerName) {
      setCompanyNameValidation({
        msg: "Please Enter Customer Name",
        invalid: true,
      });
      invalid = true;
    }
    if (!delCountry) {
      setCountryCodeValidation({
        msg: "Please Select Country",
        invalid: true,
      });
      invalid = true;
    }
    if (!delAddress1) {
      setAddress1Validation({
        msg: "Please Enter Address 1",
        invalid: true,
      });
      invalid = true;
    }
  }
  if (
    !isCollectOrder &&
    !requestNewAddress &&
    (defaultDelivery === "" || defaultDelivery === "0")
  ) {
    setDelAddressDropValidation({
      msg: "Please Select Address",
      invalid: true,
    });
    invalid = true;
  }
  return invalid;
};

export const setDeliveryAddressValidationFalse = (
  setCountryCodeValidation,
  setContactValidation,
  setCompanyNameValidation,
  setAddress1Validation,
  setDelAddressDropValidation
) => {
  setCountryCodeValidation(initialValidation);
  setContactValidation(initialValidation);
  setCompanyNameValidation(initialValidation);
  setAddress1Validation(initialValidation);
  setDelAddressDropValidation(initialValidation);
};
